// extracted by mini-css-extract-plugin
module.exports = {"devTools":"DevTools_devTools__jXdgC"};